import { Row, Typography } from "@commonlibs";
import clsx from "clsx";
import { useTheme } from "styled-components";
import { DropdownValueProps } from "./DropdownValue.types";

export default function DropdownValue({ prefix, suffix, label, className, style, ...rest }: DropdownValueProps): JSX.Element {
    const { spacing } = useTheme();

    return (
        <Row
            justifyContent={"center"}
            gap={spacing[4]}
            alignItems={"center"}
            className={clsx(className, "dropdown")}
            style={style}
            {...rest}
        >
            {prefix}
            <Typography variant="body2Strong" numberOfLines={1} css={{ flex: 1, wordBreak: "break-all" }}>
                {label}
            </Typography>
            {suffix}
        </Row>
    );
}
